import React from 'react';
import { StoreProvider, useStore } from './context/StoreContext';
import Navbar from './components/Navbar';
import CartDrawer from './components/CartDrawer';
import AdminLock from './components/AdminLock';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Account from './pages/Account';
import Admin from './pages/Admin';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import { Icons } from './components/Icons';
import useScrollReveal from './utils/useScrollReveal';
import './App.css';

function AppInner() {
  const { page, openWA } = useStore();
  useScrollReveal();

  return (
    <div className="app">
      <Navbar />

      <main>
        <div className={page === 'home' ? 'page-visible' : 'page-hidden'}><Home /></div>
        <div className={page === 'shop' ? 'page-visible' : 'page-hidden'}><Shop /></div>
        <div className={page === 'product' ? 'page-visible' : 'page-hidden'}><ProductDetail /></div>
        <div className={page === 'about' ? 'page-visible' : 'page-hidden'}><About /></div>
        <div className={page === 'contact' ? 'page-visible' : 'page-hidden'}><Contact /></div>
        <div className={page === 'account' ? 'page-visible' : 'page-hidden'}><Account /></div>
        <div className={page === 'admin' ? 'page-visible' : 'page-hidden'}><Admin /></div>
        <div className={page === 'blog' ? 'page-visible' : 'page-hidden'}><Blog /></div>
        <div className={page === 'blogpost' ? 'page-visible' : 'page-hidden'}><BlogPost /></div>
        <div className={page === 'privacy-policy' ? 'page-visible' : 'page-hidden'}><PrivacyPolicy /></div>
        <div className={page === 'terms' ? 'page-visible' : 'page-hidden'}><Terms /></div>
      </main>

      <Footer />

      {/* WhatsApp FAB */}
      <button className="wa-fab" onClick={openWA} title="Chat on WhatsApp">
        {Icons.whatsapp(26)}
      </button>

      {/* Cart & Lock */}
      <CartDrawer />
      <AdminLock />
    </div>
  );
}

export default function App() {
  return (
    <StoreProvider>
      <AppInner />
    </StoreProvider>
  );
}
